/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/* eslint-disable no-unused-vars */
import React, {Component} from 'react';
import {setForceHideNavbar} from '../../actions/appActions';
import {connect} from 'react-redux';

/* eslint-enable no-unused-vars */
import './Learn.scss';

type Props = {
	locale: string;
	env: string;
	match: any;
	setForceHideNavbar: Function;
	forceHideNavbar: boolean;
	history: any;
	location: any;
	profile: {
		productEntitlements: Array<string>;
		subscriptionInfo: Object;
		profileFetchFinished: boolean;
	};
};

class LearnTutorialPage extends Component<Props> {
	/**
	 * [getPathData grabs the relveant learn fields from the url]
	 * @returns {[none]}
	 */
	getPathData() {
		const path = this.props.match.url.split('/');
		return {
			app: path[2],
			level: path[3],
			field: path[4],
			playlistTitle: path[5],
			tutorialTitle: path[6],
		};
	}

	componentDidMount() {
		this.props.setForceHideNavbar(true);
	}

	componentWillUnmount() {
		this.props.setForceHideNavbar(false);
	}

	render() {
		//
		// FOR NEW DISCOVER EXPERIENCE:
		// Route all users to the new discover page.
		// Ignore any deep linking for the time being.
		//
		this.props.history.push(`/cc/discover${this.props.match.url}`);

		return null;
	}
}

function mapStateToProps(state) {
	return {
		forceHideMenu: state.app.forceHideMenu,
		leftNavOpen: state.app.leftNavOpen,
		forceHideNavbar: state.app.forceHideNavbar,
		profile: state.profile,
	};
}

export default {
	component: connect(mapStateToProps, {setForceHideNavbar})(LearnTutorialPage),
};
